import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATES_APPROVED_ROUTE_NAME = Symbol('admin.affiliates.approved');
export const ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME = Symbol('admin.affiliates.approved.list');

export const TRANSLATION_GROUP_AFFILIATES_APPROVED = Symbol('admin.affiliates.approved');

export const AFFILIATES_LIST_API_URL = 'admin/affiliates/list_approved';
export const AFFILIATE_MANAGERS_API_URL = 'admin/affiliates/list_of_affiliate_managers';
export const CHANGE_MANAGER_API_URL = 'admin/affiliates/change_manager_for_affiliates';
export const CHANGE_DEPARTMENT_API_URL = 'admin/affiliates/mass_change_departments';
export const CHANGE_NNCO_API_URL = 'admin/affiliates/change_nnco_for_affiliates';
export const DOWNLOAD_AFFILIATES_REPORT_API_URL = 'admin/affiliates/download_list_approved';
export const CHANGE_AFFILIATE_STATUS_API_URL = 'admin/affiliates/:affiliateId/change_ban_status';
export const AFFILIATES_DEPARTMENT_LIST_URL = 'admin/affiliates/list_of_affiliate_departments';

export const AFFILIATES_LIST_QUERY_KEY = 'affiliates.list';
export const AFFILIATE_MANAGERS_QUERY_KEY = 'affiliate.managers';
export const CHANGE_MANAGER_MUTATION_KEY = 'affiliate.change-manager';
export const CHANGE_DEPARTMENT_MUTATION_KEY = 'affiliate.change-department';
export const CHANGE_AFFILIATE_STATUS_MUTATION_KEY = 'affiliate.change-status';
export const CHANGE_NNCO_MUTATION_KEY = 'affiliate.change-nnco';
export const DOWNLOAD_AFFILIATES_REPORT_MUTATION_KEY = 'affiliate.download-report';
export const AFFILIATES_DEPARTMENT_LIST_QUERY_KEY = 'affiliates.department.list';

export const AFFILIATES_SUPERVISION_API_URL = 'admin/affiliates/:id/enable_supervision';
export const AFFILIATES_SUPERVISION_MUTATION_KEY = 'affiliates.supervision';

export const AFFILIATES_APPROVED_PERMISSIONS = {
  AFFILIATES_SHOW: new Permission(
    PermissionsList.admin.AFFILIATES_SHOW,
  ),
  SUPERVISION: new Permission(
    PermissionsList.admin.AFFILIATES_SUPERVISION,
  ),
  CHANGE_BAN_STATUS: new Permission(
    PermissionsList.admin.AFFILIATES_CHANGE_BAN_STATUS,
  ),
  DOWNLOAD_LIST_APPROVED: new Permission(
    PermissionsList.admin.AFFILIATES_DOWNLOAD_LIST_APPROVED,
  ),
  CHANGE_MANAGER_FOR_AFFILIATES: new Permission(
    PermissionsList.admin.AFFILIATES_CHANGE_MANAGER_FOR_AFFILIATES,
  ),
  UPDATE_DEPARTMENT_FOR_AFFILIATES: new Permission(
    PermissionsList.admin.AFFILIATES_UPDATE_DEPARTMENT,
  ),
  CHANGE_NNCO_FOR_AFFILIATES: new Permission(
    PermissionsList.admin.AFFILIATES_CHANGE_NNCO_FOR_AFFILIATES,
  ),
};
